import { fetchMenuCategories, fetchMenuItems } from '@/services/menuService'

export default {
    async fetchMenuItems({ commit }, { orderTypeId, sourceId, divisionId }) {
        const response = await fetchMenuItems(orderTypeId, sourceId, divisionId)
        commit('SET_MENU', response.data?.items || [])
    },

    async fetchMenuCategories(
        { commit },
        { orderTypeId, sourceId, divisionId }
    ) {
        const response = await fetchMenuCategories(
            divisionId,
            orderTypeId,
            sourceId
        )
        commit('SET_TO_MENU_CATEGORIES', response.data?.categories || [])
    },
}
